import { Input, Popover, Radio } from "antd";
import { useEffect, useState } from "react";
import {
  AlignRight,
  ChevronLeft,
  Gift,
  Grid,
  Home,
  Search,
  X,
} from "react-feather";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  DISPLAY_VIEW,
  NUMBER_LIMIT_PERMISSTION,
  SORT_MODE,
} from "../../constants/commons";
import { useDebounce } from "../../hook/useDebounce";
import { setDisplayMode } from "../../stores/reducers/displayMode.reducer";
import { useRootSelector } from "../../stores/reducers/root";
import {
  setSortMode,
  setValueSearch,
} from "../../stores/reducers/sortSearch.reducer";
import { setDisplayViewToLS } from "../../utils/localStorage";
import { PERMISSION } from "../../services/ability.service";
import { IoInfinite } from "react-icons/io5";
import { path } from "../../routes/path";

type TPropsNavMenu = {
  totalAlbums?: number;
};

export const NavMenu = ({ totalAlbums }: TPropsNavMenu) => {
  const { t } = useTranslation();
  const dispath = useDispatch();
  const displayMode = useRootSelector((state) => state.displayMode.mode);
  const user = useRootSelector((state) => state.user.userProfile);
  const sortMode = useRootSelector((state) => state.sortSearch.mode);
  const [value, setValue] = useState<string>("");
  const debounce = useDebounce<string>({ value, delay: 500 });
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };
  const onChangeDisplayMode = (e: any) => {
    dispath(setDisplayMode(e.target.value));
    setDisplayViewToLS(e.target.value);
  };
  const onChangeSortMode = (e: any) => {
    dispath(setSortMode(e.target.value));
  };

  let numberLimit: any =
    user.membership_plan.plan_permissions?.find(
      (per) => per.name === PERMISSION.NUM_ALBUM
    ).number || 0;

  numberLimit =
    numberLimit > NUMBER_LIMIT_PERMISSTION ? <IoInfinite /> : numberLimit;

  useEffect(() => {
    dispath(setValueSearch(debounce));
  }, [debounce, dispath]);

  const contentView = (
    <Radio.Group
      name="displayView"
      defaultValue={displayMode}
      className="flex flex-col gap-2"
      onChange={onChangeDisplayMode}
    >
      <Radio value={DISPLAY_VIEW[0]}>
        {t("dashboard.control.display.value1")}
      </Radio>
      <Radio value={DISPLAY_VIEW[1]}>
        {t("dashboard.control.display.value2")}
      </Radio>
    </Radio.Group>
  );

  const contentSort = (
    <Radio.Group
      name="sortAlbums"
      defaultValue={sortMode}
      className="flex flex-col gap-2"
      onChange={onChangeSortMode}
    >
      <Radio value={SORT_MODE[0]}>
        {t("dashboard.control.arrange.value1")}
      </Radio>
      <Radio value={SORT_MODE[1]}>
        {t("dashboard.control.arrange.value2")}
      </Radio>
    </Radio.Group>
  );

  return (
    <div className="flex sm:flex-row flex-col flex-wrap">
      <div className="flex sm:space-x-3 text-sm items-center flex-wrap sm:flex-nowrap">
        <Popover content={contentSort} trigger="click">
          <div className="py-1 px-3 flex gap-1 items-center cursor-pointer transition-all hover:bg-gray-200/40 dark:hover:bg-bg-tertiary rounded-3xl">
            <AlignRight className="w-4" />
            {t("dashboard.control.arrange.title")}
          </div>
        </Popover>
        <Popover content={contentView} trigger="click">
          <div className="py-1 px-3 flex gap-1 items-center cursor-pointer transition-all hover:bg-gray-200/40 dark:hover:bg-bg-tertiary rounded-3xl">
            <Grid className="w-4" /> {t("dashboard.control.display.title")}
          </div>
        </Popover>
        <div className="py-1 px-3 flex gap-1 cursor-pointer transition-all hover:bg-gray-200/40 dark:hover:bg-bg-tertiary rounded-3xl">
          {t("dashboard.control.albumNumber")}:
          <div className="text-black dark:text-text-primary font-medium">
            {totalAlbums || 0}
          </div>
        </div>
        <div className="py-1 px-3 flex gap-1 cursor-pointer transition-all hover:bg-gray-200/40 dark:hover:bg-bg-tertiary rounded-3xl">
          {t("dashboard.control.albumNumberPerMonth")}:
          <div className="text-black dark:text-text-primary font-medium text-nowrap flex flex-nowrap items-center">
            {user.album_in_month}/{numberLimit}
          </div>
        </div>
        <Link
          to={path.referral}
          className="flex gap-1 items-center py-[5px] px-3 text-red-500 hover:opacity-85 bg-yellow-300 transition-all rounded-full font-medium"
        >
          <Gift className="w-4 sm:block hidden" />
          <div className="sm:block hidden pt-0.5">
            {t("headerDashboard.referral")}
          </div>
          <Gift className="w-4 block sm:hidden" />
        </Link>
      </div>
      <Input
        placeholder={t("dashboard.control.placeholderSearch")}
        className="w-full md:w-48 lg:w-64 md:ml-auto py-1 px-3 md:mt-0 mt-1"
        prefix={
          <div className="-ml-1 text-gray-500 dark:text-text-muted">
            <Search className="w-4" />
          </div>
        }
        suffix={
          !!value ? (
            <div className="hover:bg-gray-100 dark:hover:bg-bg-tertiary px-1 cursor-pointer w-fit rounded-md -mr-2 text-gray-500 dark:text-text-muted">
              <X className="w-4" onClick={() => setValue("")} />
            </div>
          ) : (
            <></>
          )
        }
        value={value}
        onChange={handleOnChange}
      />
    </div>
  );
};
